// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2388":"33bc6a32","4310":"589183b5","4758":"779523b1","5295":"33bc6a32","6152":"33bc6a32","9540":"06a66844"}[chunkId] + ".chunk.css";
};